import React from 'react';
import './UniformTables.css';

const UniformTables = ({ grades }) => {
  const clothingSizes = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  const shoeSizes = ['12', '13', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];

  // Helper to convert tahun number to text
  const tahunToText = (tahun) => {
    const map = {
      '1': 'SATU',
      '2': 'DUA',
      '3': 'TIGA',
      '4': 'EMPAT',
      '5': 'LIMA',
      '6': 'ENAM'
    };
    return map[tahun] || tahun;
  };

  // Calculate totals for each size across all grades
  const calculateTotals = (prefix) => {
    const totals = {};
    clothingSizes.forEach(size => {
      totals[size] = grades.reduce((sum, grade) => {
        const key = `${prefix}_${size}`;
        return sum + (grade[key] || 0);
      }, 0);
    });
    totals['JUMLAH'] = Object.values(totals).reduce((sum, val) => sum + val, 0);
    return totals;
  };

  const calculateShoeTotals = () => {
    const totals = {};
    shoeSizes.forEach(size => {
      totals[size] = grades.reduce((sum, grade) => {
        const key = `kasut_${size}`;
        return sum + (grade[key] || 0);
      }, 0);
    });
    totals['JUMLAH'] = Object.values(totals).reduce((sum, val) => sum + val, 0);
    return totals;
  };

  // Render table for one uniform type
  const renderUniformTable = (title, prefix) => {
    const totals = calculateTotals(prefix);

    return (
      <div className="uniform-table-container">
        <table className="uniform-table">
          <thead>
            <tr>
              <th>TAHUN</th>
              <th colSpan={clothingSizes.length}>SAIZ</th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <th>{title}</th>
              {clothingSizes.map(size => (
                <th key={size}>{size}</th>
              ))}
              <th>JUMLAH</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {grades.map((grade, idx) => {
              const rowTotal = clothingSizes.reduce((sum, size) => {
                return sum + (grade[`${prefix}_${size}`] || 0);
              }, 0);
              const isCompleted = grade.status?.toLowerCase() === 'closed';

              return (
                <tr key={idx} className={isCompleted ? 'completed' : ''}>
                  <td>{tahunToText(grade.tahun)}</td>
                  {clothingSizes.map(size => (
                    <td key={size}>{grade[`${prefix}_${size}`] || 0}</td>
                  ))}
                  <td><strong>{rowTotal}</strong></td>
                  <td>{grade.status || ''}</td>
                </tr>
              );
            })}
            <tr className="total-row">
              <td><strong>JUMLAH</strong></td>
              {clothingSizes.map(size => (
                <td key={size}><strong>{totals[size]}</strong></td>
              ))}
              <td><strong>{totals['JUMLAH']}</strong></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  // Render shoes table
  const renderShoesTable = () => {
    const totals = calculateShoeTotals();

    return (
      <div className="uniform-table-container" style={{ width: '100%' }}>
        <table className="uniform-table shoes-table">
          <thead>
            <tr>
              <th>TAHUN</th>
              <th colSpan={shoeSizes.length}>SAIZ</th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <th>KASUT (SHOES)</th>
              {shoeSizes.map(size => (
                <th key={size}>{size}</th>
              ))}
              <th>JUMLAH</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {grades.map((grade, idx) => {
              const rowTotal = shoeSizes.reduce((sum, size) => {
                return sum + (grade[`kasut_${size}`] || 0);
              }, 0);
              const isCompleted = grade.status?.toLowerCase() === 'closed';

              return (
                <tr key={idx} className={isCompleted ? 'completed' : ''}>
                  <td>{tahunToText(grade.tahun)}</td>
                  {shoeSizes.map(size => (
                    <td key={size}>{grade[`kasut_${size}`] || 0}</td>
                  ))}
                  <td><strong>{rowTotal}</strong></td>
                  <td>{grade.status || ''}</td>
                </tr>
              );
            })}
            <tr className="total-row">
              <td><strong>JUMLAH</strong></td>
              {shoeSizes.map(size => (
                <td key={size}><strong>{totals[size]}</strong></td>
              ))}
              <td><strong>{totals['JUMLAH']}</strong></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="uniform-tables">
      {/* Row 1: BP KOLAR KERAS + PINAFORE */}
      <div className="tables-row">
        {renderUniformTable('BP KOLAR KERAS', 'bajuPutih')}
        {renderUniformTable('PINAFORE', 'pinafore')}
      </div>

      {/* Row 2: SELUAR PANJANG + BAJU KURUNG */}
      <div className="tables-row">
        {renderUniformTable('SELUAR PANJANG', 'seluarPanjang')}
        {renderUniformTable('BAJU KURUNG', 'bajuKurung')}
      </div>

      {/* Row 3: SELUAR PENDEK + KAIN KURUNG */}
      <div className="tables-row">
        {renderUniformTable('SELUAR PENDEK', 'seluarPendek')}
        {renderUniformTable('KAIN KURUNG', 'kainKurung')}
      </div>

      {/* Row 4: KASUT (full width) */}
      <div className="tables-row">
        {renderShoesTable()}
      </div>
    </div>
  );
};

export default UniformTables;
